module.exports = __webpack_public_path__ + "media/img/service-img-995f3348.png";